import Request from '../../../../src/core/gd/data/request'
import CustomEntity from "./custom-entity"

export default class ApiCustomEntity {

    constructor() {}

    static create(customEntity:CustomEntity) {
        return new Request(this,'POST','custom-entity/create',customEntity.toJSON())
    }

    static get(customEntity:CustomEntity) {
        return new Request(this,'POST','custom-entity/{0}'.f(customEntity.id),customEntity.toJSON())
    }

    static update(customEntity:CustomEntity){
        return new Request(this,'PUT','custom-entity/{0}'.f(customEntity.id), customEntity.toJSON())
    }

    static delete(customEntity:CustomEntity){
        return new Request(this,'DELETE','custom-entity/{0}'.f(customEntity.id))
    }
}
